import {useEffect, useState} from "react";
import {CountrySelector} from "react-international-phone";
import {verifyCodeOTP, verifyTelephone} from "../../../services/AuthService";
import {Navigate, useLocation, useNavigate} from "react-router-dom";
import SixDigitInput from "../../components/shared/CodeInputTel";
import {useDispatch} from "react-redux";
import {signupwithSCAction} from "../../../store/actions/AuthActions";
import {
  getOtpErrorMessage,
  isValidOtpPhone,
  normalizePhoneForOtp,
} from "../../../utils/otp";
import TurnstileWidget from "../../components/shared/TurnstileWidget";

const SocialAuth = () => {
  const location = useLocation();
  const {userInfo, idToken, signedBy} = location.state || {};

  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("fr");
  const [dialCode, setDialCode] = useState("+33");
  const [selectedRole, setSelectedRole] = useState("2");
  const [genre, setGenre] = useState("");
  const [birthDate, setBirthDate] = useState("");
  let errorsObj = {phone: "", genre: "", birthDate: ""};
  const [errors, setErrors] = useState(errorsObj);
  const [verify, setVerify] = useState(false);
  const [verifCode, setVerifCode] = useState(new Array(6).fill(""));
  const [telStep, setTelStep] = useState(false);
  const [otpPhone, setOtpPhone] = useState("");
  const [isSendingCode, setIsSendingCode] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [turnstileRequired, setTurnstileRequired] = useState(true);
  const [turnstileResetKey, setTurnstileResetKey] = useState(0);
  const [turnstileError, setTurnstileError] = useState("");
  const storageKey = "helpclic_social_registration_profile";

  useEffect(() => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || "null");
      if (saved?.gender) setGenre(saved.gender);
      if (saved?.birthDate) setBirthDate(saved.birthDate);
      if (saved?.roleId) setSelectedRole(String(saved.roleId));
    } catch (_) {
      sessionStorage.removeItem(storageKey);
    }
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const normalizedPhone = normalizePhoneForOtp(dialCode, phone);

  if (!userInfo) {
    return <Navigate to={"/login"} />;
  }

  const handelSubmit = () => {
    let error = false;
    let savedProfile = {};
    try {
      savedProfile = JSON.parse(sessionStorage.getItem(storageKey) || "{}") || {};
    } catch (_) {
      savedProfile = {};
    }
    const submittedGender = genre || savedProfile.gender || "";
    const submittedBirthDate = birthDate || savedProfile.birthDate || "";
    const submittedRole = savedProfile.roleId || selectedRole || "2";

    const errorObj = {...errorsObj};
    if (phone === "") {
      errorObj.phone = "champ obligatoire";
      error = true;
    }
    if (!submittedGender) {
      errorObj.genre = "champ obligatoire";
      error = true;
    }
    if (!submittedBirthDate) {
      errorObj.birthDate = "champ obligatoire";
      error = true;
    }
    if (!otpPhone || otpPhone !== normalizedPhone) {
      errorObj.phone =
        "Le numéro a changé. Renvoyez le code avant de continuer.";
      error = true;
    }
    const newCode = verifCode.join("");
    if (newCode.length < 6) {
      errorObj.verif = "Le code de vérification n'est pas valide.";
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }

    verifyCodeOTP({
      phone: otpPhone,
      code: newCode,
    })
      .then((response) => {
        dispatch(
          signupwithSCAction(
            {
              ...userInfo,
              phone: normalizedPhone,
              gender: submittedGender,
              genre: submittedGender,
              birthDate: submittedBirthDate,
              dateOfBirth: submittedBirthDate,
              roleId: submittedRole,
              signedBy,
              idToken,
            },
            navigate
          )
        );
      })
      .catch((err) => {
        setErrors((prev) => ({
          ...prev,
          verif: getOtpErrorMessage(err, "verify"),
        }));
      });
  };

  const handelCode = async () => {
    let error = false;
    const errorObj = {...errorsObj};

    if (!isValidOtpPhone(normalizedPhone)) {
      errorObj.phone = "Le numéro de téléphone n'est pas valide.";
      error = true;
    }
    if (turnstileRequired && !turnstileToken) {
      setTurnstileError("Veuillez valider la protection anti-robot.");
      error = true;
    }

    setErrors(errorObj);
    if (error) {
      return;
    }
    // setPhone(dialCode + phone);

    try {
      setIsSendingCode(true);
      await verifyTelephone({
        email: userInfo.email,
        phone: normalizedPhone,
        language: "fr",
        turnstileToken: turnstileToken || "",
      });
      setOtpPhone(normalizedPhone);
      setVerifCode(new Array(6).fill(""));
      setErrors((previous) => ({...previous, phone: "", verif: ""}));
      setVerify(true);
    } catch (err) {
      setErrors((previous) => ({
        ...previous,
        phone: getOtpErrorMessage(err, "send"),
      }));
    } finally {
      setTurnstileToken(null);
      setTurnstileResetKey((current) => current + 1);
      setIsSendingCode(false);
    }
  };

  const handleNext = () => {
    let error = false;
    const errorObj = {...errorsObj};
    if (genre === "") {
      errorObj.genre = "champ obligatoire";
      error = true;
    }
    if (birthDate === "") {
      errorObj.birthDate = "champ obligatoire";
      error = true;
    }
    if (turnstileRequired && !turnstileToken) {
      setTurnstileError("Veuillez valider la protection anti-robot.");
      error = true;
    }
    setErrors(errorObj);
    if (!error) {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          gender: genre,
          birthDate,
          roleId: selectedRole,
        }),
      );
      setTelStep(true);
    }
  };

  return (
    <>
      <div className="row m-0 justify-content-center h-100 align-items-center">
        <div className="col-xl-6 col-xxl-8">
          <div className="authincation-content">
            <div className="row no-gutters">
              <div className="col-xl-12">
                <div className="auth-form">
                  <div className=" mb-3">
                    <h2 className="text-primary font-bold text-[26px] uppercase">
                      {!telStep
                        ? `Se connecter avec ${signedBy}`
                        : "vérification du numéro de téléphone"}
                    </h2>

                    {!telStep ? (
                      <>
                        <div className="flex flex-col sm:flex-row gap-2 w-full ">
                          <div className="form-group w-full sm:w-1/2">
                            <label className="font-bold text-sm leading-9 text-[#7E7E7E] ">
                              Genre
                            </label>
                            <select
                              className="form-control custom-select-arrow"
                              name="gender"
                              onChange={(e) => setGenre(e.target.value)}
                              value={genre}
                            >
                              <option value={""} selected hidden disabled>
                                --
                              </option>
                              <option value={"female"}>Femme</option>
                              <option value={"male"}>Homme</option>
                              <option value={"other"}>Autre</option>
                            </select>
                            {errors.genre && (
                              <div
                                className="invalid-feedback animated fadeInUp"
                                style={{display: "block"}}
                              >
                                {errors.genre}
                              </div>
                            )}
                          </div>
                          <div className="form-group w-full sm:w-1/2">
                            <label className="font-bold text-sm leading-9 text-[#7E7E7E] ">
                              Date de naissance
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              name="birthDate"
                              onChange={(e) => setBirthDate(e.target.value)}
                              value={birthDate}
                            />
                            {errors.birthDate && (
                              <div
                                className="invalid-feedback animated fadeInUp"
                                style={{display: "block"}}
                              >
                                {errors.birthDate}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="font-bold text-sm leading-9 text-[#7E7E7E] ">
                            Vous êtes Client ou Prestataire ?
                          </label>
                          <div className="flex w-full">
                            <label className="cursor-pointer w-1/2">
                              <input
                                type="radio"
                                name="role"
                                value="2"
                                className="hidden"
                                checked={selectedRole === "2"}
                                onChange={() => setSelectedRole("2")}
                              />
                              <div
                                className={`px-4 py-2 text-center rounded-s-lg border-2 ${
                                  selectedRole === "2"
                                    ? "bg-[#FF6600] text-white border-[#FF6600]"
                                    : "bg-white text-gray-700 border-gray-300"
                                }`}
                              >
                                Client
                              </div>
                            </label>
                            <label className="cursor-pointer w-1/2">
                              <input
                                type="radio"
                                name="role"
                                value="3"
                                className="hidden"
                                checked={selectedRole === "3"}
                                onChange={() => setSelectedRole("3")}
                              />
                              <div
                                className={`px-4 py-2 text-center rounded-e-lg border-2 ${
                                  selectedRole === "3"
                                    ? "bg-[#FF6600] text-white border-[#FF6600]"
                                    : "bg-white text-gray-700 border-gray-300"
                                }`}
                              >
                                Prestataire
                              </div>
                            </label>
                          </div>
                        </div>

                        <TurnstileWidget
                          onTokenChange={setTurnstileToken}
                          onRequirementChange={setTurnstileRequired}
                          resetKey={turnstileResetKey}
                        />
                        {turnstileError && (
                          <div className="mb-2 text-danger fs-12">
                            {turnstileError}
                          </div>
                        )}
                        <div className="text-center">
                          <button
                            type="button"
                            onClick={handleNext}
                            className="btn text-white hover:!bg-[#1a71b9] !bg-[#1A64B9] !border-[#1A64B9]  btn-block uppercase"
                          >
                            Suivant
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="form-group">
                          <label className="mb-2 ">Numéro de téléphone</label>

                          <div className="flex gap-2 justify-start items-center">
                            <CountrySelector
                              className="flex justify-start items-center"
                              dropdownArrowClassName="absolute  right-0"
                              flagClassName="absolute left-2"
                              selectedCountry={country}
                              onSelect={(el) => {
                                setCountry(el.iso2);
                                setDialCode("+" + el.dialCode);
                                setErrors((previous) => ({
                                  ...previous,
                                  phone: "",
                                }));
                              }}
                              renderButtonWrapper={({children, rootProps}) => (
                                <button
                                  type="button"
                                  {...rootProps}
                                  className=" w-[100px] h-[51px] max-[1400px]:h-[41px] bg-white border rounded-lg relative"
                                >
                                  {children}
                                  <div className="absolute top-[13px] max-[1400px]:top-[8px] right-5">
                                    {dialCode}
                                  </div>
                                </button>
                              )}
                            />
                            <input
                              type="tel"
                              className="form-control"
                              value={phone}
                              onChange={(e) => {
                                setPhone(e.target.value);
                                setErrors((previous) => ({
                                  ...previous,
                                  phone: "",
                                }));
                              }}
                            />
                            {errors.phone && (
                              <div className="text-danger fs-12">
                                {errors.phone}
                              </div>
                            )}
                          </div>
                        </div>

                        {!turnstileToken && (
                          <TurnstileWidget
                            onTokenChange={setTurnstileToken}
                            onRequirementChange={setTurnstileRequired}
                            resetKey={turnstileResetKey}
                          />
                        )}
                        {turnstileError && (
                          <div className="mb-2 text-danger fs-12">
                            {turnstileError}
                          </div>
                        )}

                        {verify ? (
                          <>
                            <h1 className="w-full font-medium text-base text-center text-[#3D4465] mt-2">
                              Un code de vérification a été envoyé sur votre
                              téléphone
                            </h1>
                            <div className="form-group mt-8">
                              <label className="mb-2 ">Entrer votre code</label>
                              <SixDigitInput
                                small={true}
                                values={verifCode}
                                setValues={setVerifCode}
                              />
                              {errors.verif && (
                                <div className="text-danger text-center fs-12">
                                  {errors.verif}
                                </div>
                              )}

                              <div
                                onClick={isSendingCode ? undefined : handelCode}
                                className={`mt-2 text-right font-medium text-[#7E7E7E] leading-4 text-sm underline ${
                                  isSendingCode
                                    ? "cursor-not-allowed opacity-60"
                                    : "cursor-pointer"
                                }`}
                              >
                                {isSendingCode
                                  ? "Envoi en cours..."
                                  : "Renvoyer le code ?"}
                              </div>
                            </div>
                            <div className="text-center">
                              <button
                                onClick={handelSubmit}
                                type="button"
                                className="btn text-white hover:!bg-[#1a71b9] !bg-[#1A64B9] !border-[#1A64B9]  btn-block uppercase"
                              >
                                Enregistrer
                              </button>
                            </div>
                          </>
                        ) : (
                          <div className="text-center">
                            <button
                              onClick={handelCode}
                              type="button"
                              disabled={isSendingCode}
                              className="btn text-white hover:!bg-[#1a71b9] !bg-[#1A64B9] !border-[#1A64B9]  btn-block uppercase"
                              style={{
                                backgroundColor: "#1a71b9",
                                borderColor: "#1a71b9",
                                color: "#fff",
                              }}
                            >
                              {isSendingCode
                                ? "Envoi en cours..."
                                : "Envoyer un code de verification"}
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SocialAuth;
